export default function Wallet(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M26.6406 21.4546H26.658"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.36213 9.36383H30.0891C31.997 9.36383 33.5436 10.9104 33.5436 12.8183V30.0908C33.5436 31.9987 31.997 33.5455 30.0891 33.5453H5.90762C3.99972 33.5455 2.45312 31.9987 2.45312 30.0908V5.90933C2.45312 4.00143 3.99972 2.45469 5.90762 2.45483H30.0891"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
